import i18n from "i18n";
import lod_ from "lodash";
import { useEffect, useState } from "react";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import MDButton from "components/Basics/MDButton";
import MDBox from "components/Basics/MDBox";
import FormAction from "redux-react/actions/formAction";
import { useDispatch, useSelector } from "react-redux";
import { COLLECTIONS } from "pages/settings/promptStudio/constants";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import MDTypography from "components/Basics/MDTypography";

const LinkAction = ({
	value,
	onChangeGate,
	openDialogAction,
	setOpenDialogAction,
	whitelistDynamic,
	values
}) => {
	const [targetChild, setTargetChild] = useState("");
	const [solutions, setSolutions] = useState([]);
	const [applySolution, setApplySolutions] = useState([]);
	const [actionCodeList, setactionCodeList] = useState([]);

	const dispatch = useDispatch();
	const profile = useSelector(selectCurrentProfile);
	const user = useSelector(state => state.user);
	// const [targetWD, setTargetWD] = useState({});

	const language = profile?.language || user?.language || "FR";

	// init value for first render
	useEffect(() => {
		const onSuccessActionProcess = res => {
			if (!lod_.isNil(res?.items[0]?.content)) {
				// SET FOR START DEFAULT DATA FOR LIST OF ACTION BUT LATER REPLACE BY CONFIG
				setactionCodeList([
					{ label: "Pas d'action", value: null },

					{ label: "Suspendre l'abonnement", value: "suspendSubscription" },
					{ label: "Reprendre l'abonnement", value: "resumeSubscription" },
					{
						label: "Réduction Abonnement",
						value: "offerDiscountSubscription"
					},

					{ label: "Arrêter l'abonnement", value: "cancelSubscription" },
					{
						label: "Arrêter et rembourser totalement l'abonnement",
						value: "cancelAndRefundSubscription"
					},
					{
						label: "Arrêter et rembourser partiellement l'abonnement",
						value: "cancelAndPartialRefundSubscription"
					},
					{
						label: "Arrêter et rembourser 50%",
						value: "offerDiscountSubscription50"
					},
					{
						label: "Nouvel abonnement",
						value: "newSubscription"
					}
				]);

				setSolutions(res?.items[0]?.content);
				const existValue = lod_.get(values, "actionsProcess");
				if (!lod_.isNil(existValue) && !lod_.isEmpty(existValue)) {
					setApplySolutions(existValue);
				} else {
					setApplySolutions([]);
				}
			} else {
				setSolutions([]);
			}
		};

		switch (whitelistDynamic?.action) {
			case "getAnswerItemSteps":
				if (!lod_.isNil(value) && !lod_.isEmpty(value)) {
					setTargetChild("actionsProcess");

					dispatch(
						FormAction.getItemsFromCollection(
							COLLECTIONS.answerItem,
							{
								query: { code: value },
								projection: { _id: 0, content: 1, code: 1 }
							},
							onSuccessActionProcess
						)
					);
				} else {
					setTargetChild("");
					setSolutions([]);
					setApplySolutions([]);
					setactionCodeList([]);
				}
				break;
			default:
				setTargetChild("");
				setSolutions([]);
				setApplySolutions([]);
				setactionCodeList([]);
				break;
		}
	}, []);

	// CLOSE POP-UP RESET DATA
	const handleClose = () => {
		setTargetChild("");
		setSolutions([]);
		setApplySolutions([]);
		setactionCodeList([]);
		setOpenDialogAction(false);
	};

	// VALIDE SELECTION OF DATA (ACTIONS)
	const validateLink = () => {
		let event = { target: { name: targetChild, value: applySolution } };
		onChangeGate(event);
		handleClose();
	};

	// TO GET CORRECT VALUE FOR SHOW/UPDATE (ACTIONS)
	const getValueAction = targetValue => {
		let result;
		if (!lod_.isNil(applySolution) && !lod_.isEmpty(applySolution)) {
			const findResult = applySolution.find(item => item.value === targetValue);
			if (!lod_.isNil(findResult) && !lod_.isEmpty(findResult)) {
				result = findResult.action;
			}
		}
		return result;
	};

	// TO UPDATE LIST OF ACTION LINK TO ADD OR UPDATE ALREADY EXIST
	const changeValueAction = (changeValue, targetValue) => {
		if (!lod_.isNil(applySolution)) {
			const findIndex = applySolution.findIndex(item => item.value === targetValue);
			if (!lod_.isNil(findIndex)) {
				setApplySolutions(prev => {
					let newList = lod_.cloneDeep(prev);
					if (findIndex === -1) {
						const newAction = { value: targetValue, action: changeValue };
						newList.push(newAction);
					} else {
						lod_.set(newList, `[${findIndex}].action`, changeValue);
					}
					return newList;
				});
			}
		}
	};

	return (
		<Dialog open={openDialogAction} onClose={() => handleClose()}>
			<DialogTitle>{i18n.t("FORMS.linkActionTitle")}</DialogTitle>
			<DialogContent>
				{targetChild === "actionsProcess" && !lod_.isEmpty(solutions) ? (
					<>
						{solutions.map((item, key) => (
							<MDBox key={key} mb={2}>
								<MDTypography variant="body1" mb={1}>
									{key + 1} -{" "}
									{!lod_.isNil(item[language.toUpperCase()]?.menu?.subject)
										? item[language.toUpperCase()]?.menu?.subject
										: ""}
								</MDTypography>
								{!lod_.isNil(item[language.toUpperCase()]?.menu?.choices) &&
									!lod_.isEmpty(item[language.toUpperCase()]?.menu?.choices) &&
									item[language.toUpperCase()]?.menu?.choices.map((choice, key) => (
										<MDBox
											key={key}
											pb={1}
											style={{
												display: "flex",
												flexDirection: "row",
												alignItems: "center",
												width: "100%"
											}}
										>
											<MDBox pr={1}>{choice.label}</MDBox>
											{!lod_.isNil(actionCodeList) && !lod_.isEmpty(actionCodeList) ? (
												// FOR USE WD IF GO WITH ACTION
												// <LogicManagerWD
												// 	child={targetChild}
												// 	value={value}
												// 	whitelistDynamic={targetWD}
												// />
												<FormControl fullWidth>
													<InputLabel id="select-type">{i18n.t("FORMS.choiceAction")}</InputLabel>
													<Select
														labelId="select-type"
														fullWidth
														value={getValueAction(choice?.value) || ""}
														label={i18n.t("FORMS.choiceAction")}
														onChange={e => changeValueAction(e.target.value, choice?.value)}
													>
														{actionCodeList
															.sort((a, b) => a.label.localeCompare(b.label))
															.map((item, index) => {
																return (
																	<MenuItem key={index} value={item.value}>
																		{item.label}
																	</MenuItem>
																);
															})}
													</Select>
												</FormControl>
											) : (
												<MDBox>Aucune configuration disponible pour cette action</MDBox>
											)}
										</MDBox>
									))}
							</MDBox>
						))}
					</>
				) : (
					<MDBox>La réponse type comporte pas de solution</MDBox>
				)}
			</DialogContent>
			<DialogActions>
				<MDButton autoFocus onClick={() => handleClose()} variant="outlined" color="info">
					{i18n.t("FORMS.cancel")}
				</MDButton>
				<MDButton onClick={() => validateLink()} color="info" variant="contained" autoFocus>
					{i18n.t("FORMS.validate")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

// START OF WD FOR GET ACTION
// TO DO -> DELETE IF NOT USE FOR
// const LogicManagerWD = ({ child, value, onchangeAction, whitelistDynamic, listAPIs }) => {
// 	const [valueAuto, setValueAuto] = useState(value);
// 	const [optionAuto, setOptionAuto] = useState([]);
// 	const assistantIDs = useSelector(state => selectCurrentProfile(state).assistantID);
// 	const { user } = useSelector(state => state);

// 	async function loadSuggestions(searchText, searchFields, apiName, action, limit = 10) {
// 		let attribute = whitelistDynamic?.params?.attribute;

// 		let APIFind;
// 		let actionFind;
// 		if (apiName && action && !lod_.isEmpty(listAPIs)) {
// 			APIFind = listAPIs.find(item => item.name === apiName) || {};
// 			actionFind = APIFind.config.action[action];
// 		} else {
// 			return [];
// 		}

// 		let account = actionFind?.account ?? false;
// 		// Merge collections is an array of collections name, that will be requested in the same time
// 		// The result will be merged in the same array
// 		const mergeCollections = actionFind?.mergeCollections || [];

// 		let config = {
// 			method: actionFind?.method,
// 			maxBodyLength: Infinity,
// 			url: `${APIFind.config.host}/api/v1/ressource/${actionFind?.collection}/dynamic?search=${searchText}&page=1&limit=${limit}&account=${account}`,
// 			data: { filter: actionFind?.filter, searchFields, attribute, mergeCollections },
// 			headers: {
// 				Authorization: `Bearer ${user.token}`,
// 				assistantID: assistantIDs,
// 				"Content-Type": "application/json"
// 			}
// 		};

// 		let result;
// 		await axios
// 			.request(config)
// 			.then(response => {
// 				result = response.data;
// 			})
// 			.catch(error => {
// 				// console.log(error);
// 			});
// 		return result?.results || [];
// 	}

// 	const onChangeCRM = (event, newValue, option) => {
// 		if (option === "selectOption") {
// 			setValueAuto(newValue[whitelistDynamic.params.attribute]);
// 			event = { target: { name: child, value: newValue[whitelistDynamic.params.attribute] } };
// 			onchangeAction(event);
// 		} else if (option === "clear") {
// 			setValueAuto("");
// 			event = { target: { name: child, value: null } };
// 			onchangeAction(event);
// 		}
// 	};

// 	const getOptionLabel = option => {
// 		let labelAttribute = option[whitelistDynamic?.params?.attribute] || "";
// 		let label = whitelistDynamic.params?.searchFields
// 			? whitelistDynamic.params?.searchFields.map(key => option[key]).join(" - ")
// 			: "";
// 		if (
// 			whitelistDynamic.params?.searchFields &&
// 			!lod_.isEmpty(whitelistDynamic.params?.searchFields)
// 		) {
// 			label = labelAttribute + " - " + label;
// 		} else {
// 			label = labelAttribute;
// 		}

// 		return label;
// 	};

// 	const ValueChange = async valueC => {
// 		setValueAuto(valueC);

// 		let result = await loadSuggestions(
// 			valueC,
// 			whitelistDynamic.params?.searchFields || [],
// 			whitelistDynamic.apiName,
// 			whitelistDynamic.action
// 		);

// 		setOptionAuto(result);
// 	};

// 	return (
// 		<MDBox style={{ width: "100%", display: "flex" }}>
// 			<Autocomplete
// 				id="auto"
// 				freeSolo
// 				disableClearable
// 				fullWidth
// 				name={child}
// 				options={optionAuto}
// 				onChange={onChangeCRM}
// 				getOptionLabel={getOptionLabel}
// 				inputValue={valueAuto || ""}
// 				renderInput={params => (
// 					<MDInput {...params} label="Code action" onChange={e => ValueChange(e.target.value)} />
// 				)}
// 			/>
// 		</MDBox>
// 	);
// };
export default LinkAction;
